module.exports = __webpack_public_path__ + "static/media/Ben Leduc-Mills.2187771b.png";